import React from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ReactComponent as WarningIcon } from '../_images/exclamation-triangle.svg';

function GenericPopup({ show, text, onHide, icon, footer }) {

    function replaceNewlines(text) {
        return text.split('\n').map((item, key) => {
            return <span key={key} style={{overflowWrap: 'break-word'}}>{item}<br/></span>
        });
    }

    function formatText(text) {
        if (text.includes('\n')) {
            return replaceNewlines(text);
        } else {
            return text;
        }
    }

    return (
        <Modal show={show} backdrop="static" onHide={onHide}>
            <Modal.Header style={{justifyContent: "center"}}>
                {icon}
            </Modal.Header>
            <Modal.Body>{formatText(text)}</Modal.Body>
            <Modal.Footer>
                {footer}
            </Modal.Footer>
        </Modal>
    )
}

export default GenericPopup
